<template>
  <section class="basket-kits-card" :class="{ 'basket-kits-card_active': active }">
    <span class="basket-kits-card__header">
      <span>
        <DefImg v-if="result.picture" :result="result.picture" max-width="100px" />
      </span>
      <GiaPhoto v-if="result.isGia" />
      <DefBuySecondary :result="result" @click.stop>
        <svg>
          <use xlink:href="#svg-plus"></use>
        </svg>
        <template #inBasket>
          <svg class="def-buy__icon"><use xlink:href="#svg-check"></use></svg>
        </template>
      </DefBuySecondary>
    </span>
    <span class="basket-kits-card__footer">
      <span class="basket-kits-card__name">{{ result.type }}</span>
      <span v-if="result.price" class="basket-kits-card__prices">
        <DefPrice v-if="result.price.printPrice">{{ result.price.printPrice }}</DefPrice>
        <DefPriceOld v-if="result.price.printPriceOld">{{
          result.price.printPriceOld
        }}</DefPriceOld>
      </span>
    </span>
  </section>
</template>

<script setup>
import DefImg from '@components/Def/DefImg/DefImg.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefPrice from '@components/Def/DefPrice/DefPrice.vue';
import DefPriceOld from '@components/Def/DefPriceOld/DefPriceOld.vue';
import { defineProps } from 'vue';
import DefBuySecondary from '@components/Def/DefBuy/DefBuySecondary.vue';

const props = defineProps(['result', 'active']);
</script>

<style lang="scss" scoped>
.basket-kits-card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative;
  padding: 8px;
  cursor: pointer;
  &:hover {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 1px solid var(--background-beige);
      animation: clippath 3s linear reverse;
      pointer-events: none;
    }
  }
  &_active {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border: 1px solid var(--background-beige);
      pointer-events: none;
    }
  }
  @keyframes clippath {
    0%,
    100% {
      clip-path: inset(0 0 95% 0);
    }
    25% {
      clip-path: inset(0 95% 0 0);
    }
    50% {
      clip-path: inset(95% 0 0 0);
    }
    75% {
      clip-path: inset(0 0 0 95%);
    }
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 8px;
  }
  &__footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    padding-bottom: 22px;
    @include point-md {
      padding-bottom: 16px;
    }
    @include point-lg {
      padding-bottom: 19px;
    }
  }
  &__prices {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  &__name {
    text-align: center;
    margin-bottom: 12px;
    max-height: 14px;
    overflow: hidden;
    transition: 0.2s linear color;
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    text-transform: uppercase;
    &:hover {
      color: var(--color-link-hover-dark);
    }
  }
  :deep(.def-price) {
    font-size: 14px;
  }
  :deep(.gia-photo) {
    position: absolute;
    right: 12px;
    bottom: 12px;
  }
  :deep(.def-button-secondary) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background-color: #f3f3f6;
    position: absolute;
    top: 0;
    right: 0;
    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
